import { render, staticRenderFns } from "./setNewPassword.vue?vue&type=template&id=d0d85588&scoped=true&"
import script from "./setNewPassword.vue?vue&type=script&lang=js&"
export * from "./setNewPassword.vue?vue&type=script&lang=js&"
import style0 from "./setNewPassword.vue?vue&type=style&index=0&id=d0d85588&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d85588",
  null
  
)

export default component.exports